<template>
    <div class=""></div>
</template>


<script>
export default {
    data() {
        return {

        }
    },
    beforeCreate() {
        console.log('beforeCreate7777777777778888888888888888');
    }, 
    created() {
        console.log('created7777777777778888888888888888');
    }, 
    beforeMount() {
        console.log('beforeMount7777777777778888888888888888');
    }, 
    mounted() {
        console.log('mounted7777777777778888888888888888');
    }, 
    beforeUpdate() {
        console.log('beforeUpdate7777777777778888888888888888');
    }, 
    updated() {
        console.log('updated7777777777778888888888888888');
    }, 
    beforeDestroy() {
        console.log('beforeDestroy7777777777778888888888888888');
    },
    destroyed() {
        console.log('destroyed7777777777778888888888888888');
    },
    methods: {

    }
}
</script>